var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"src":'/img/' + _vm.getIcon(_vm.filename),"alt":_vm.filename,"scale":'scale-' + _vm.scale}})}
var staticRenderFns = []

export { render, staticRenderFns }